export default __webpack_public_path__ + "static/char-s-34-zh-Hant-c4d19841d5e0b9b51b9d44e6443e3e79.png";